import React from "react";
import Cardimage from "./Cardimage.js";

const Team = (props) => {
  return (
    <div>
      <div>
        <h2 className="blue-text-no-margin">Meet Our Team</h2>
      </div>
      <Cardimage />
    </div>
  );
};
export default Team;
